import React from 'react'
import {
  Badge,
  Text,
  Button,
  Paragraph,
  Textarea,
  toaster,
  Popover,
  Dialog,
  Strong,
  TextInput,
  TextInputField,
  Pane
} from 'evergreen-ui'

const index = ({ onReschedule, bookingId, rescheduleEnableText,startTime }) => {
  return (
    <Pane
      display={'flex'}
      flexDirection={'column'}
      border
      borderRadius={5}
      padding={15}
      marginBottom={10}
    >
      {' '}
      <Pane
        display='flex'
        flexDirection='row'
        alignItems='center'
        justifyContent={'space-between'}
      >
        {' '}
        <Strong color={'#696f8c'}>Enable Reschedule </Strong>{' '}
        <Button
          appearance='minimal'
         
          onClick={() => {
            onReschedule(bookingId,startTime)
          }}
        >
          <Strong color='#0679c5'>Enable</Strong>
        </Button>
      </Pane>
      <Pane marginTop={10}>
        <Text>{rescheduleEnableText}</Text>
      </Pane>
    </Pane>
  )
}

export default index
